import { debounce } from "lodash";
import GeoService from "~/services/GeoService";

const defaultOptions = {
  debounceTimeout: 200,
  debounceLeading: false,
  debounceTrailing: true,
};

/**
 * Compatibility shim — replaces the former google.maps.Geocoder wrapper.
 * Callers that still hold a Geocoder instance (TourBuilderPage, ModalTourBuilderWidget)
 * continue to work without changes; the actual API calls go through GeoService.
 */
class Geocoder {
  constructor(optionsOverrides = {}) {
    const options = { ...defaultOptions, ...optionsOverrides };

    this.geocode = debounce(this._geocode.bind(this), options.debounceTimeout, {
      leading: options.debounceLeading,
      trailing: options.debounceTrailing,
    });
  }

  _geocode(request, callback) {
    const query = (request && request.address) || '';
    GeoService.geocode(query)
      .then(location => {
        if (!location) {
          callback([]);
          return;
        }
        // Return a minimal shape with the fields consumers need
        callback([location]);
      })
      .catch(() => callback([]));
  }
}

export default Geocoder;
